/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../variables';
@use '../../mixins';

//calc-variables
$header-height: variables.$header-height;
$padding: variables.$padding-large;

#divi-navigation {
  width: 100%;
}

.divi-container a {
  position: relative;

  &.done {
    @include mixins.divi-navi-overlay(
      variables.$color-corpuls-system-green-lightest,
      variables.$color-corpuls-system-green-lightest,
      variables.$color-corpuls-system-green-light,
      variables.$color-corpuls-system-green-light
    );
  }
  &.touched {
    @include mixins.divi-navi-overlay(
      variables.$color-corpuls-system-yellow-lightest,
      variables.$color-corpuls-system-yellow-lightest,
      variables.$color-corpuls-system-yellow-light,
      variables.$color-corpuls-system-yellow-light
    );
  }
  &.todo {
    @include mixins.divi-navi-overlay(
      variables.$color-corpuls-system-red-lightest,
      variables.$color-corpuls-system-red-lightest,
      variables.$color-corpuls-system-red-light,
      variables.$color-corpuls-system-red-light
    );
  }
  &.active {
    @include mixins.divi-navi-overlay(variables.$color-orange, transparent, variables.$color-orange, transparent);
  }
}

//divi grid definitions
.divi-one {
  display: grid;
  grid-template-columns: 98px 21px 117px;
  grid-template-rows: 102px 41px 103px 77px 43px;
  gap: 5px 5px;
  grid-auto-flow: row;
  grid-template-areas:
    'pat incident-data incident-data'
    'anamnese anamnese anamnese'
    'neurology neurology data-initial'
    'medical-conditions medical-conditions injuries'
    'medical-conditions medical-conditions initial-diagnosis';
  margin-bottom: variables.$margin-large;
}

.divi-two {
  display: grid;
  grid-template-columns: 57px 84px 93px;
  grid-template-rows: 117px 73px 23px 39px 54px 43px;
  gap: 5px 5px;
  grid-auto-flow: row;
  grid-template-areas:
    'course course measures'
    'medication medication measures'
    'reanimationdeath reanimationdeath measures'
    'handover handover handover'
    'specifics remarks remarks'
    'handover-to remarks remarks';
}

.divi-navigation-symbol-container {
  display: flex;
  justify-content: space-between;

  .divi-navigation-symbol-icon {
    padding: 2px;
    z-index: 100;
  }
}

//divi grid area allocation
#pat {
  grid-area: pat;
  background-image: url('./../../assets/images/diviPage1/image1.jpg');
  @include mixins.fix-background;
}
#incident-data {
  grid-area: incident-data;
  background-image: url('./../../assets/images/diviPage1/image2.png');
  @include mixins.fix-background;
}
#anamnese {
  grid-area: anamnese;
  background-image: url('./../../assets/images/diviPage1/image3.png');
  @include mixins.fix-background;
}
#neurology {
  grid-area: neurology;
  background-image: url('./../../assets/images/diviPage1/image4.png');
  @include mixins.fix-background;
}
#data-initial {
  grid-area: data-initial;
  background-image: url('./../../assets/images/diviPage1/image5.png');
  @include mixins.fix-background;
}
#medical-conditions {
  grid-area: medical-conditions;
  background-image: url('./../../assets/images/diviPage1/image6.png');
  @include mixins.fix-background;
}
#injuries {
  grid-area: injuries;
  background-image: url('./../../assets/images/diviPage1/image7.png');
  @include mixins.fix-background;
}
#initial-diagnosis {
  grid-area: initial-diagnosis;
  background-image: url('./../../assets/images/diviPage1/image8.png');
  @include mixins.fix-background;
}
#course {
  grid-area: course;
  background-image: url('./../../assets/images/diviPage2/image1.png');
  @include mixins.fix-background;
}
#medication {
  grid-area: medication;
  background-image: url('./../../assets/images/diviPage2/image2.png');
  @include mixins.fix-background;
}
#reanimation-death {
  grid-area: reanimationdeath;
  background-image: url('./../../assets/images/diviPage2/image3.png');
  @include mixins.fix-background;
}
#measures {
  grid-area: measures;
  background-image: url('./../../assets/images/diviPage2/image4.png');
  @include mixins.fix-background;
}
#handover {
  grid-area: handover;
  background-image: url('./../../assets/images/diviPage2/image5.png');
  @include mixins.fix-background;
}
#specifics {
  grid-area: specifics;
  background-image: url('./../../assets/images/diviPage2/image6.png');
  @include mixins.fix-background;
}
#handover-to {
  grid-area: handover-to;
  background-image: url('./../../assets/images/diviPage2/image7.png');
  @include mixins.fix-background;
}
#remarks {
  grid-area: remarks;
  background-image: url('./../../assets/images/diviPage2/image8.png');
  @include mixins.fix-background;
}
